var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreakpointsStudioDesktop = function SvgBreakpointsStudioDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16h-11A1.502 1.502 0 0 1 5 14.5v-8A1.502 1.502 0 0 1 6.5 5h11A1.502 1.502 0 0 1 19 6.5v8a1.502 1.502 0 0 1-1.5 1.5ZM6.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h11a.501.501 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-11ZM16 18H8v1h8v-1Z",
    fill: "#fff"
  })));
};
export default SvgBreakpointsStudioDesktop;